<!-- eslint-disable prettier/prettier -->
<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0 mt-n3">
        <v-form @submit.prevent="filterTicket">
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header class="body-1 font-weight-bold">
                Filtros
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mb-5">
                <v-row>
                  <v-col cols="6" sm="2">
                    <BaseSelect
                      label="Intervalo de Datas"
                      :items="$relatorios_sinteticos.intervalo_data"
                      item-text="text"
                      item-value="value"
                      v-model="filter.intervalo_datas"
                      placeholder="Selecione o intervalo de datas"
                      v-show="openFilters"
                    />
                  </v-col>
                  <v-col cols="6" sm="2" v-if="!mdAndUp">
                    <BaseSelect
                      label="Tipo de Ingresso"
                      tabindex="2"
                      item-text="descricao"
                      item-value="idvariacao"
                      placeholder="Selecione o tipo de ingresso"
                      clearable
                      hide-details
                      :items="saleTicket.ingressos"
                      v-model="filter.ingresso"
                    />
                  </v-col>
                  <v-col
                    cols="6"
                    sm="2"
                    v-if="this.filter.intervalo_datas != 'custom' && mdAndUp"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <BaseTextField
                          label="Datas"
                          v-model="dateRangeText"
                          :append-icon="$config.icons.calendar"
                          readonly
                          :disabled="
                            filter.intervalo_datas != null ? false : true
                          "
                          v-bind="attrs"
                          v-on="on"
                          :placeholder="placeholderData"
                          :color="$config.dados.corinputs"
                          clearable
                          @click:clear="filter.range_dates = []"
                        >
                        </BaseTextField>
                      </template>
                      <v-date-picker
                        v-model="computeRange"
                        @input="menu = false"
                        :active-picker.sync="activePicker"
                        @change="computeRange"
                        locale="pt"
                        @click:month="monthEvent"
                        no-title
                        range
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" sm="2" md="2" v-else>
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <BaseTextField
                          label="Datas"
                          v-model="dateRangeText"
                          :append-icon="$config.icons.calendar"
                          readonly
                          :disabled="
                            filter.intervalo_datas != null ? false : true
                          "
                          v-bind="attrs"
                          v-on="on"
                          :placeholder="placeholderData"
                          :color="$config.dados.corinputs"
                          clearable
                          @click:clear="filter.range_dates = []"
                        >
                        </BaseTextField>
                      </template>
                      <v-date-picker
                        v-model="filter.range_dates"
                        :active-picker.sync="activePicker"
                        locale="pt"
                        no-title
                        @input="
                          filter.range_dates.length == 2
                            ? (menu = false)
                            : (menu = true)
                        "
                        :color="$config.dados.corinputs"
                        range
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" sm="2" v-if="mdAndUp">
                    <BaseSelect
                      label="Tipo de Ingresso"
                      tabindex="2"
                      item-text="descricao"
                      placeholder="Selecione o tipo de ingresso"
                      clearable
                      hide-details
                      :items="saleTicket.ingressos"
                      v-model="filter.ingresso"
                    />
                  </v-col>
                  <v-col cols="1">
                    <v-btn
                      class="rounded-lg"
                      color="#572c88"
                      dark
                      type="submit"
                    >
                      Filtrar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-col>
      <v-col cols="12" sm="12" md="12" class="px-0 mt-n3">
        <v-data-table
        flat
        class="rounded-lg"
        no-data-text="Não há registro de vendas"
        loading-text="Buscando informações..."
        :headers="headers"
        :items="filtersTicket.vendas"
        :items-per-page="10"
        :sort-by="'dthr_ultima_venda'"
        :sort-desc="true"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50],
          itemsPerPageText: 'Vendas por página:',
        }"
        >
          <!-- comentado por não funcionar no momento, deixar para implementar futuramente -->
          <template v-slot:top>
            <v-col
              top
              class="d-flex justify-end"
              style="max-height: 70px"
            >
              <v-menu rounded offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
  
                <v-list>
                  <v-list-item
                    @click="exportPapper(item)"
                    v-for="(item, index) in items"
                    :key="index"
                    link
                  >
                    <v-icon :size="iconExport">{{ item.icon }}</v-icon>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </template>
          <template v-slot:item.dthr_ultima_venda="{ item }">
            {{ item.dthr_ultima_venda | dthr_pt_br }}
          </template>
          <template v-slot:item.valor_ultima_venda="{ item }">
            {{ item.valor_ultima_venda | moeda }}
          </template>
          <template v-slot:item.ticket_medio="{ item }">
            {{ item.ticket_medio | moeda }}
          </template>
          <template v-slot:footer>
            <v-data-table
              no-data-text="Não há registro de vendas por dia."
              loading-text="Buscando informações..."
              hide-default-footer
              :headers="headersTotals"
              :items="filtersTicket.totais"
              :header-props="{
                disableSort: true,
              }"
            >
              <template v-slot:item.total_vendas="{ item }">
                {{ item.total_vendas | moeda }}
              </template>
            </v-data-table>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import displayHelpers from "@/mixins/breakpoints.mixins";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import dayjs from "dayjs";
export default {
  name: "ReportDash",
  components: {
    BaseTextField,
    BaseSelect,
  },
  mixins: [displayHelpers],
  data() {
    return {
      filter: {
        ingresso: "",
        intervalo_datas: null,
        range_dates: []
      },
      placeholderData: "dd/mm/aa ~ dd/mm/aa",
      date: null,
      menu: false,
      activePicker: null,
      dayjs: dayjs,
      openFilters: false,
      sortBy: "dthr_ultima_venda",
      sortDesc: true,
      items: [
        { icon: "mdi-file-pdf-box", action: this.downloadPDF },
        { icon: "mdi-microsoft-excel", action: this.downloadExcel },
      ],
      headers: [
        {
          text: "Última venda",
          value: "dthr_ultima_venda",
          align: "center",
          sortable: true,
          width: 140,
        },
        {
          text: "Ingressos vendidos",
          value: "quantidade_vendida",
          align: "center",
          sortable: true,
          width: 100,
        },
        {
          text: "Ingressos restantes",
          value: "quantidade_restante",
          align: "center",
          sortable: true,
          width: 230,
        },
        {
          text: "Tipo de ingresso",
          value: "descricao",
          align: "start",
          sortable: true,
          width: 230,
        },
        {
          text: "Total",
          value: "valor_ultima_venda",
          align: "center",
          sortable: true,
          width: 100,
        },
        {
          text: "Ticket médio",
          value: "ticket_medio",
          align: "center",
          sortable: true,
          width: 100,
        },
      ],
      headersTotals: [
        {
          text: "Quantidade total de vendas",
          value: "qtd_vendas",
          align: "center",
          sortable: false,
        },
        {
          text: "Total de ingressos restantes",
          value: "qtd_restante",
          align: "center",
          sortable: false,
        },
        {
          text: "Total de vendas",
          value: "total_vendas",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "dashEvent",
      "dashEventLoading",
      "dashEventHasData",
      "checkinEvent",
      "salesByTicketDashLoading",
      "saleTicket",
      "filtersTicket",
    ]),
    sizeIconExport() {
      return this.mdAndUp ? 34 : 30;
    },
    iconExport() {
      return this.mdAndUp ? 34 : 30;
    },
    computeRange: {
      get() {
        return this.filter.range_dates;
      },
      set([firstDay]) {
        switch (this.filter.intervalo_datas) {
          case "date": {
            // const day = new Date(new Date(firstDay).setDate(new Date(firstDay).getDate())).toISOString().slice(0, 10);
            this.filter.range_dates = [firstDay, firstDay];
            break;
          }
          case "week": {
            const currentDayWeek = this.dayjs(firstDay)
              .day(0)
              .format("YYYY-MM-DD");
            const week = this.dayjs(firstDay).day(6).format("YYYY-MM-DD");
            this.filter.range_dates = [currentDayWeek, week];
            break;
          }
          case "month": {
            const currentDayMonth = this.dayjs(firstDay)
              .startOf("month")
              .format("YYYY-MM-DD");
            const month = this.dayjs(firstDay)
              .endOf("month")
              .format("YYYY-MM-DD");
            this.filter.range_dates = [currentDayMonth, month];
            break;
          }
          case "custom": {
            const currentDayCustom = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);
            const custom = "";
            this.filter.range_dates = [currentDayCustom, custom];
            break;
          }
          default: {
            const defaultDay = "";
            this.filter.range_dates = [firstDay, defaultDay];
            break;
          }
        }
      },
    },
    dateRangeText() {
      let arrayDates = [];
      this.filter.range_dates.forEach(item => {
        return arrayDates.push(this.$config.convertDataBR(item));
      });

      return arrayDates.join(" ~ ");
    },
    initDateFormat() {
      if (this.filter.range_dates.length > 0) {
        return `${this.filter.range_dates[0]} 00:00`;
      }

      return null;
    },
    endDateFormat() {
      if (this.filter.range_dates.length > 0) {
        return `${this.filter.range_dates[1]} 23:59`;
      }

      return null;
    },
  },
  methods: {
    ...mapActions([
      "setSalesByTicketDash",
      "exportTicketPDF",
      "setFiltersTicket",
      "exportTicketPDF",
      "exportTicketCSV",
    ]),
    exportPapper(item) {
      if (item.action) {
        item.action();
      }
    },
    downloadPDF() {
      const filters = {
        dt_inicial: this.initDateFormat || "",
        dt_final: this.endDateFormat || "",
        ingresso: this.filter.ingresso || "",
      };
      this.$store.dispatch("exportTicketPDF", {
        idproduto: this.dashEvent.idproduto,
        filtros: filters,
      });
    },
    downloadExcel() {
      const filters = {
        dt_inicial: this.initDateFormat || "",
        dt_final: this.endDateFormat || "",
        ingresso: this.filter.ingresso || "",
      };
      this.$store.dispatch("exportTicketCSV", {
        idproduto: this.dashEvent.idproduto,
        filtros: filters,
      });
    },
    filterTicket() {
      const filters = {
        dt_inicial: this.initDateFormat || "",
        dt_final: this.endDateFormat || "",
        ingresso: this.filter.ingresso || "",
      };
      this.$store.dispatch("setFiltersTicket", {
        idproduto: this.dashEvent.idproduto,
        filtros: filters,
      });
    },
    replaceSpecialChars(str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, "A");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "E");
      str = str.replace(/[Ç]/, "C");
      str = str.replace(/[ç]/, "c");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "");
    },
    monthEvent(month) {
      const currentDayMonth = this.dayjs(month)
        .startOf("month")
        .format("YYYY-MM-DD");
      const monthEnd = this.dayjs(month).endOf("month").format("YYYY-MM-DD");
      this.filter.range_dates = [currentDayMonth, monthEnd];
    },
  },
  watch: {
    "this.filter.intervalo_datas"(e) {
      switch (e) {
        case "date": {
          const currentDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          // const day = new Date(new Date(currentDay).setDate(new Date(currentDay).getDate() + 1)).toISOString().slice(0, 10);
          this.filter.range_dates = [currentDay, currentDay];
          break;
        }
        case "week": {
          const currentDayWeek = this.dayjs().day(0).format("YYYY-MM-DD");
          const week = this.dayjs().day(6).format("YYYY-MM-DD");
          this.filter.range_dates = [currentDayWeek, week];
          break;
        }
        case "month": {
          const currentDayMonth = this.dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          const month = this.dayjs().endOf("month").format("YYYY-MM-DD");
          this.filter.range_dates = [currentDayMonth, month];
          break;
        }
        case "custom": {
          const currentDayCustom = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const custom = new Date(
            new Date(currentDayCustom).setDate(
              new Date(currentDayCustom).getDate() + 1
            )
          )
            .toISOString()
            .slice(0, 10);
          this.filter.range_dates = [currentDayCustom, custom];
          break;
        }
        default: {
          const defaultDay = new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10);
          const defaultDayCustom = new Date(
            new Date(defaultDay).setDate(new Date(defaultDay).getDate() + 1)
          )
            .toISOString()
            .slice(0, 10);
          this.filter.range_dates = [defaultDay, defaultDayCustom];
          break;
        }
      }
    },
    menu(val) {
      val &&
        setTimeout(() => {
          if (val && this.filter.intervalo_datas == "date") {
            this.activePicker = "DATE";
          } else if (val && this.filter.intervalo_datas == "week") {
            this.activePicker = "DATE";
          } else if (val && this.filter.intervalo_datas == "month") {
            this.activePicker = "MONTH";
          } else if (val && this.filter.intervalo_datas == "custom") {
            this.activePicker = "DATE";
          } else {
            this.activePicker = "DATE";
          }
        });
    },
  },
  destroyed() {
    (this.intervalo_datas = ""), (this.range_dates = []);
  },
};
</script>

<style scoped>
thead > tr > th {
  display: flex !important;
  left: 20px !important;
  /* align-self: center !important; */
  /* position: -webkit-sticky !important; */
  /* position: sticky !important; */
  /* right: 0; */
  /* background-color: #fff; */
}
thead > tr > th {
  padding: 0 8px !important;
  color: #000000;
  text-align: center !important;
}

.table-body {
  width: 100%;
  margin-top: 1.25rem !important;
  align-items: center !important;
  justify-content: center !important;
}
</style>
